import React from "react";
import "./ContactForm.css";

const ContactForm = () => {
  return (
    <section id="contact-us">
      <div className="contact-container">
        <div className="contact-box">
          <h2>Contact Us</h2>

          <form
            action="https://api.web3forms.com/submit"
            method="POST"
            className="contact-form"
          >
            {/* Web3Forms Access Key */}
            <input
              type="hidden"
              name="access_key"
              value="590e09d3-f6b0-4edd-aef4-6eb26cc6da4f"
            />

            {/* Honeypot Spam Protection */}
            <input
              type="checkbox"
              name="botcheck"
              className="hidden"
              style={{ display: "none" }}
            />

            {/* Optional: Redirect to thank-you page */}
            {/* <input type="hidden" name="redirect" value="https://yourdomain.com/thanks.html" /> */}

            <input
              type="text"
              name="name"
              placeholder="Full Name"
              required
              className="contact-input"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              required
              className="contact-input"
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              required
              className="contact-input"
            />
            <textarea
              name="message"
              placeholder="Any comments on your query?"
              rows="4"
              required
              className="contact-textarea"
            ></textarea>

            <button type="submit" className="contact-button">
              Send
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
